import React, { useEffect, useState } from "react";
import { CustomModal } from "../../components/styledComponent/styledModal";
import {
  StyledButton,
  StyledInput,
  StyledPasswordInput,
  StyledSelect,
} from "../../components/styledComponent/styledElements";
import { Col, Divider, Form, Radio, Row } from "antd";
import AddressFormField from "../../components/address/addressFormField";
import { listAllStaff } from "../../server/staffServices";
import { getCustomerDetails } from "../../server/customerServices";
import { useAppContext } from "../../contexts/appContext";

const CustomerCreationModal = ({
  showCreationModal = false,
  setShowCreationModal,
  onSubmit,
  onUpdate,
  formRef,
  updateId,
  setUpdateId,
}) => {
  const { startLoading, stopLoading } = useAppContext();

  const [staffList, setStaffList] = useState([]);

  const onSubmitForm = () => {
    formRef.current.submit();
  };
  const onCancelForm = () => {
    formRef.current.resetFields();
    setShowCreationModal(false);
    setUpdateId(null);
  };
  const fetchStaffs = () => {
    startLoading();
    listAllStaff()
      .then((res) => {
        var staffoption = res.data.map((val) => ({
          value: val.id,
          label: val.name,
        }));
        setStaffList(staffoption);
      })
      .catch((err) => console.log("Error on fetching Staffs", err))
      .finally(() => stopLoading());
  };
  const fetchCustomerDetails = async () => {
    startLoading();
    try {
      let res = await getCustomerDetails(updateId);
      formRef.current.setFieldsValue({
        staff: res.data.customer.staff_assigned,
        ...res.data.customer,
        address: { ...res.data.address },
      });
    } catch (error) {
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchStaffs();
    if (updateId) {
      fetchCustomerDetails();
    }
  }, []);

  return (
    <CustomModal
      title={updateId ? "Update Customer Details" : "Add Customer"}
      open={showCreationModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      okText={"Add"}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          {updateId ? "Update" : "Save"}
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />
      <Form
        ref={formRef}
        layout="vertical"
        onFinish={updateId ? onUpdate : onSubmit}
      >
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                { required: true, message: "Please enter customer name!" },
              ]}
            >
              <StyledInput width={"100%"} placeholder="Enter Fullname" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="ERP Id"
              name="erp_id"
              rules={[
                {
                  required: true,
                  message: "Please enter customer erp id!",
                  min: 0,
                },
              ]}
            >
              <StyledInput
                type="number"
                placeholder="Enter ERP ID"
                width={"100%"}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Contact Number"
              name="contact_no"
              rules={[
                { required: true, message: "Please enter contact number!" },
              ]}
            >
              <StyledInput
                type="number"
                placeholder="Enter Contact number"
                width={"100%"}
                min={0}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Email Id"
              name="email"
              rules={[
                { required: true, message: "Please enter customer email id!" },
              ]}
            >
              <StyledInput
                placeholder="example@mail.com"
                width={"100%"}
                disabled={updateId ? true : false}
              />
            </Form.Item>
          </Col>
          {!updateId && (
            <Col span={6}>
              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please enter password!" }]}
              >
                <StyledPasswordInput placeholder="Password" width={"100%"} />
              </Form.Item>
            </Col>
          )}
          <Col span={6}>
            <Form.Item label="Company Name" name="company_name">
              <StyledInput width={"100%"} placeholder="Enter Company Name" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="VAT No." name="vat_no">
              <StyledInput width={"100%"} placeholder="Enter VAT number" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="CR No." name="cr_number">
              <StyledInput
                type="number"
                width={"100%"}
                placeholder="Enter CR number"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Staff"
              name="staff"
              rules={[
                { required: true, message: "Please enter assigned staff!" },
              ]}
            >
              <StyledSelect
                placeholder="Select a Staff"
                width={"100%"}
                options={staffList}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="VIP customer"
              name={"is_vip"}
              initialValue={false}
            >
              <Radio.Group
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Special Case"
              name={"is_blind"}
              initialValue={false}
            >
              <Radio.Group
                options={[
                  { label: "Yes", value: true },
                  { label: "No", value: false },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="Address Type"
              name={["address", "address_type"]}
              initialValue="Plain"
            >
              <StyledSelect
                placeholder="Select Address type"
                width={"100%"}
                disabled
                options={[{ label: "Plain", value: "Plain" }]}
              />
            </Form.Item>
          </Col>
          <AddressFormField prefixName="address" />
        </Row>
      </Form>
    </CustomModal>
  );
};

export default CustomerCreationModal;
